module.exports = __webpack_public_path__ + "media/music.ec8bf6f4.wav";